import React from "react"
import Map from "../shared/about/Map"

const parameters = 'pb=!1m14!1m8!1m3!1d3201.1369567160104!2d139.0533036!3d36.6471557!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601e4371d82298c1%3A0xb717df710cf75849!2snico!5e0!3m2!1sja!2sjp!4v1747295179033!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>'

const AboutMap = () => {
  return <Map parameters={ parameters } />
}

export default AboutMap
